// extracted by mini-css-extract-plugin
export default {"formWrapper":"form-wrapper_formWrapper__OQVZF","actionBtnWrapper":"form-wrapper_actionBtnWrapper__25Upm","nextBtn":"form-wrapper_nextBtn__8np6H"};